import { render } from "./ProductInventoryLocationViewPage.vue?vue&type=template&id=46cb95f8"
import script from "./ProductInventoryLocationViewPage.vue?vue&type=script&lang=js"
export * from "./ProductInventoryLocationViewPage.vue?vue&type=script&lang=js"
script.render = render

export default script